/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';
import { SET_IS_STREAMING_RESTRICTED } from './streamingrestriction.types';

export const setIsStreamingRestrictedAction = (isStreamingRestricted: boolean): AnyAction => ({
    type: SET_IS_STREAMING_RESTRICTED,
    payload: {
        isStreamingRestricted,
    },
});
